import { InvoiceLineModel } from "@insite/client-framework/Types/ApiModels";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const mapInvoiceLineModel = (
    invoiceLine: InvoiceLineModel,
    options?: Toolkit.GoogleAnalytics.Options,
): Toolkit.GoogleAnalytics.Item => {
    const {
        brand,
        description,
        discountAmount,
        discountPercent,
        productERPNumber,
        qtyInvoiced,
        shortDescription,
        unitOfMeasure,
        unitPrice,
    } = invoiceLine;

    return {
        discount: discountAmount === 0 ? undefined : discountAmount,
        discount_percentage: discountPercent === 0 ? undefined : discountPercent * 100,
        item_brand: brand?.name,
        item_id: productERPNumber,
        item_name: shortDescription || description,
        price: ga.util.parseAmount(unitPrice),
        quantity: qtyInvoiced ?? 1,
        unit_of_measure: unitOfMeasure || undefined,
        ...options?.itemData,
    };
};

export default mapInvoiceLineModel;
